import { Box, Button, Typography } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { formConfig } from "./formConfig";
import Field from "@/components/RHFcomponents/Field";

const SubscriptionForm = () => {
  // Form control using React Hook Form
  const { handleSubmit, control, reset } =
    useForm<ISubscriptionFields>(formConfig);

  const onSubmit: SubmitHandler<ISubscriptionFields> = (data) => {
    console.log("subscription", data);
    reset();
  };

  return (
    <>
      <Typography variant="h6" color="text.accent" mb={2}>
        Subscribe to our newsletter
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        gap={2}
        mb={4}
        display="flex"
        flexDirection="column"
      >
        <Field name="email" control={control} placeholder="Enter your email" />
        <Button type="submit" variant="contained" fullWidth>
          Subscribe
        </Button>
      </Box>
    </>
  );
};

export default SubscriptionForm;
